const impersonationFieldStyles = {
  panel: {
    padding: '12px 16px 14px',
    background: '#EEF1F6',
    borderTop: '1px solid #D5DCE6',
    display: 'flex',
    flexDirection: 'column',
    gap: 8,
  },
  eyebrow: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: 6,
    fontSize: 12,
    fontWeight: 700,
    color: '#3D4F6B',
    letterSpacing: '0.08em',
    textTransform: 'uppercase',
  },
  eyebrowIcon: {
    fontSize: 15,
  },
  label: {
    fontSize: 14,
    color: '#3C4043',
  },
  row: {
    display: 'flex',
    gap: 6,
  },
  input: {
    flexGrow: 1,
    minWidth: 0,
    height: 40,
    boxSizing: 'border-box',
    padding: '0 10px',
    border: '1px solid #C3CBD8',
    background: '#FFFFFF',
    font: '400 14px Roboto, sans-serif',
    color: '#202124',
    '&:focus': {
      outline: 'none',
      borderColor: '#3D4F6B',
    },
  },
  go: {
    height: 40,
    padding: '0 14px',
    border: '1px solid #3D4F6B',
    background: '#FFFFFF',
    color: '#3D4F6B',
    font: '500 14px Roboto, sans-serif',
    cursor: 'pointer',
    '&:disabled': {
      cursor: 'default',
      opacity: 0.6,
    },
  },
  error: {
    fontSize: 13,
    color: '#B3261E',
  },
}

export default impersonationFieldStyles
